<template>
  <button
    type="button"
    class="btn-action"
    :disabled="isButtonDisabled"
    @click.prevent="clickAction(action)"
  >
    {{ buttonName }}
  </button>
</template>
<script>
import { get, indexOf } from 'lodash'
import { UserService } from '@/common/api/api.service'

export default {
  name: 'PlayerActionButton',
  props: {
    clickPlayerFn: {
      type: Function
    },
    contentInfo: {
      type: Object
    },
    section: {
      type: String
    },
    landingInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      action: '',
      buttonName: '',
      isButtonDisabled: false,
      episodeNumber: ''
    }
  },
  computed: {
    hasMovieMainFilm () {
      return Number(get(this.contentInfo, 'countinfo.typeM', '0')) > 0
    },
    contentStatus () {
      return get(this.landingInfo, 'contents_status', '')
    }
  },
  methods: {
    clickAction (action) {
      switch (action) {
        case 'login' :
          return this.moveToLogin()

        case 'purchase' :
          return this.moveToVoucher()

        case 'stream' :
          return this.clickPlayerFn()
      }
    },
    moveToLogin () {
      this.$router.replace(`/member/login?referer=${this.$route.fullPath}`)
    },
    moveToVoucher () {
      const contentId = get(this.contentInfo, 'contentid', '')
      const movieId = get(this.contentInfo, 'movieid', '')
      const programId = get(this.contentInfo, 'programid', '')
      const channelId = get(this.contentInfo, 'channelid', '')
      const type = this.section === 'movie' ? 'movie' : 'voucher'
      const cpId = get(this.contentInfo, 'cpid', '')
      const playy = indexOf(get(this.contentInfo, 'moviemarks', []), 'playy') > -1 ? 'y' : 'n'
      const query = { type: type, contenttype: this.section, channelid: channelId, contentid: contentId, programid: programId, cpid: cpId }
      const movieQuery = {
        type: type,
        contenttype: this.section,
        channelid: channelId,
        contentid: movieId || contentId,
        programid: movieId || contentId,
        cpid: cpId,
        playy: playy
      }
      this.$router.push({
        name: 'voucher_popup_new_for_app',
        query: this.section === 'movie' ? movieQuery : query
      })
    },
    buttonDisplay (status) {
      let display = ''
      switch (status) {
        case 'commingsoon' :
          this.isButtonDisabled = true
          display = '공개 예정'
          break
        case 'closed' :
          this.isButtonDisabled = true
          display = '판매 종료'
          break
        case 'continue' :
          display = '이어보기'
          break
        case 'normal' :
          display = `에피소드 ${this.episodeNumber} 보기`
          break
        case 'latest' :
          display = `최신 에피소드 ${this.episodeNumber} 보기`
          break
        case 'begin' :
          display = `처음부터 보기`
          break
      }
      return display
    },
    getStreamButtonDisplay () {
      const { viewratio: viewRatio = '0' } = this.contentInfo
      const vodStatus = Number(viewRatio) > 0 ? 'continue' : this.contentStatus
      const movieStatus = Number(viewRatio) > 0 ? 'continue' : 'begin'
      const status = vodStatus || movieStatus

      return this.buttonDisplay(status)
    },
    getButtonName (data) {
      // landing info - content_status 가 comming soon 이면 view time 조회하지 않고 comming soon
      if (this.contentStatus === 'commingsoon') return this.buttonDisplay('commingsoon')
      // 구매 유도 버튼 판권 종료
      if (this.action === 'memo') return this.buttonDisplay('closed')
      // movie & movie 본편 없을 경우 '공개 예정'
      if (this.section === 'movie' && !this.hasMovieMainFilm) return this.buttonDisplay('commingsoon')

      return (this.action === 'stream')
        ? this.getStreamButtonDisplay()
        : get(data, 'display', '')
    },
    init () {
      this.episodeNumber = get(this.contentInfo, 'episodenumber', '').replace('회', '')
      let path = 'movieid'
      if (this.section === 'vod' || this.section === 'qvod') {
        path = 'contentid'
      } else if (this.section === 'live') {
        path = 'channelid'
      }
      const contentId = get(this.contentInfo, path, '')
      UserService.getPermissionForContent({ contentId, contentType: this.section }).then(({ data }) => {
        this.action = get(data, 'action', '')
        this.buttonName = this.getButtonName(data)
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
